/*
 * File: AntButton.tsx
 * Project: beaker
 * -----
 * Last Modified: 22 Apr 2022 2:43:25 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Button } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import React, { FC } from 'react';

// type CustomButtonType = 'success';
// type ExtendedButtonType = ButtonType | CustomButtonType;

interface ExtendedButtonProps extends ButtonProps {
  success?: 'true';
}

export const AntButton: FC<ExtendedButtonProps> = (props: ExtendedButtonProps) => {
  return <Button {...props} className={props.success === 'true' ? 'ant-btn-success' : ''} />;
};
